import { render, staticRenderFns } from "./VerticalNavMenu.vue?vue&type=template&id=2ca99f78&scoped=true"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenu.vue?vue&type=style&index=0&id=2ca99f78&prod&lang=scss"
import style1 from "./VerticalNavMenu.vue?vue&type=style&index=1&id=2ca99f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca99f78",
  null
  
)

export default component.exports